import Vue from 'vue'
import Vuex from 'vuex'
import * as R from 'ramda'
import createLogger from 'vuex/dist/logger'
import modules from './modules'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules,
  strict: debug,
  plugins: debug ? [createLogger()] : [],
  getters: {
    pending: R.compose(
      R.any(
        R.compose(
          R.any(R.equals(true)),
          R.values,
          R.prop('pending')
        )
      ),
      R.values
    )
  }
})
